import { JSX } from 'react';
import { Link, List, ListItem, Stack, Typography } from '@mui/material';
import GeneralDialog from 'src/components/ProntoHousingAdministration/QuestionMapping/Dialog';

interface ContactPropertyToRemoveMemberDialogProps {
  open: boolean;
  onClose: () => void;
  memberName: string;
  propertyEmail: string;
}

const ContactPropertyToRemoveMemberDialog = ({
  open,
  onClose,
  memberName,
  propertyEmail,
}: ContactPropertyToRemoveMemberDialogProps): JSX.Element => {
  return (
    <GeneralDialog
      visible={open}
      title="You selected to remove this Household Member"
      maxWidth="sm"
      fullWidth
      hideAccept
      cancelButtonText="I Understand"
      onCancel={onClose}
    >
      <Stack gap={1} mt={1}>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          In order to remove <strong>{memberName}</strong> from your Household,
          please contact{' '}
          <Link href={`mailto:${propertyEmail}`}>{propertyEmail}</Link> with:
        </Typography>
        <List sx={{ listStyleType: 'disc', pl: 3, py: 0 }}>
          <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Name of the person you wish to remove
            </Typography>
          </ListItem>
          <ListItem sx={{ display: 'list-item', px: 0, py: 0.5 }}>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Reason for removal
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </GeneralDialog>
  );
};

export default ContactPropertyToRemoveMemberDialog;
